import React from "react";
import { Card, Button } from "tabler-react";

function PaymentSuccess() {
  return (
    <div className="page">
      <div className="page-single">
        <div className="container">
          <div className="row">
            <div className="col col-login mx-auto">
              <Card>
                <Card.Body className="text-center">
                  <div className="mb-4">
                    <i
                      className="fe fe-check-circle text-success"
                      style={{ fontSize: "4rem" }}
                    />
                  </div>
                  <Card.Title>Payment Successful</Card.Title>
                  <p className="text-muted mb-4">
                    Thank you for your payment. Your transaction has been
                    completed successfully.
                  </p>
                  <p className="text-muted mb-4">
                    You can close this window now.
                  </p>
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccess;
